import React from 'react';
import formatPrice from '../../../../../../utils/formatPrice';
import {
    ModifierDiv,
    LabelContainer,
    ModifierGrid,
    RadioInput,
} from './ModifierStyle';
import { getQuatity } from './ModifierUtil';
import { TextField, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function ModifierRadio({ modifier, onChange }) {
    return (
        <ModifierDiv>
            <LabelContainer>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {modifier.label}
                </Typography>
            </LabelContainer>
            <ModifierGrid>
                {modifier.options.map(
                    (option, i) =>
                        !option.hide && (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '5px',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <label
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        // marginBottom: '5px',
                                    }}
                                >
                                    <RadioInput
                                        type="radio"
                                        id={option.id}
                                        name={modifier.id}
                                        value={option.label}
                                        checked={
                                            option.checked
                                                ? option.checked
                                                : false
                                        }
                                        onClick={(e) => {
                                            onChange(modifier.id, option.id);
                                        }}
                                        disabled={option.oos}
                                    />
                                    <span style={{ alignItems: 'center' }}>
                                        {option.label}
                                        {option.price &&
                                            option.price > 0 &&
                                            ' (+' +
                                                formatPrice(
                                                    (option.price *
                                                        getQuatity(
                                                            option.quantity
                                                        )) /
                                                        100
                                                ) +
                                                ') '}
                                        {option.desc && (
                                            <Tooltip
                                                title={option.desc}
                                                placement="top"
                                                arrow
                                                PopperProps={{
                                                    sx: { zIndex: 9999 },
                                                }}
                                            >
                                                <span
                                                    onClick={(e) =>
                                                        e.stopPropagation()
                                                    }
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    <InfoOutlinedIcon
                                                        sx={{
                                                            fontSize: 20,
                                                            color: '#757575',
                                                            cursor: 'pointer',
                                                            mb: 0,
                                                        }}
                                                    />
                                                </span>
                                            </Tooltip>
                                        )}
                                        {option.oos ? (
                                            <span
                                                style={{
                                                    backgroundColor: '#e74c3c',
                                                    color: '#FFFFFF',
                                                    borderRadius: '5px',
                                                }}
                                            >
                                                <b>Sold Out</b>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                    </span>
                                </label>
                                <TextField
                                    size="small"
                                    type="text"
                                    label="Internal Instructions"
                                    disabled={!option.checked}
                                    style={{ width: '50%', marginLeft: 10 }}
                                    value={option.internalNotes || ''}
                                    onChange={(e) =>
                                        onChange(
                                            modifier.id,
                                            option.id,
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                        )
                )}
            </ModifierGrid>
        </ModifierDiv>
    );
}
